import React from 'react';
import ComingSoon from './ComingSoon';
function TransferFund() {
    return <ComingSoon />;
}

export default TransferFund;
